import React from 'react';
import { Button } from '@mui/material';
import TimelineIcon from '@mui/icons-material/Timeline';

import RecentEvents from './RecentEvents';
import { SectionCard } from '../../../components/admin';

const RecentEventsPanel = ({ events, navigate }) => (
  <SectionCard
    title="Recent fall events"
    actions={
      <Button variant="text" size="small" endIcon={<TimelineIcon />} onClick={() => navigate('/fall-events')}>
        View all events
      </Button>
    }
    sx={{ height: '100%' }}
    contentProps={{ sx: { flexGrow: 1, pb: 0 }, direction: 'column', display: 'flex' }}
  >
    <RecentEvents events={events} navigate={navigate} />
  </SectionCard>
);

export default RecentEventsPanel;
